import { useMutation } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { OptionsWithLabelAndGroup } from 'src/components/SearchableDropdown';
import { useTenant } from 'src/providers/Tenant';
import { Configuration, patchConfiguration } from 'src/services/productInventory';
import { queryClient } from 'src/utils/testing/testUtils';

export function useProductCategoriesMutation(
  configurationPID: string,
  initialState: OptionsWithLabelAndGroup[] | undefined = []
) {
  const { accountId } = useTenant();
  const [selectedProductCategories, setSelectedProductCategories] = useState<OptionsWithLabelAndGroup[]>(initialState);

  const { mutateAsync, isLoading, isError } = useMutation(
    async (body: Partial<Configuration>) => {
      await patchConfiguration(configurationPID, body, accountId);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['getConfiguration']);
        queryClient.invalidateQueries(['productList']);
      },
    }
  );

  const handleProductCategoriesChange = useCallback(
    async (selectedProductCategories: OptionsWithLabelAndGroup[]) => {
      const selectedCategoriesValues = selectedProductCategories.map((productCat) => productCat.value);
      await mutateAsync({ productCategories: selectedCategoriesValues });
    },
    [mutateAsync]
  );

  return {
    isLoading,
    isError,
    selectedProductCategories,
    setSelectedProductCategories,
    handleProductCategoriesChange,
  };
}
